import React, { Component } from 'react';
import $ from 'jquery';
import * as GA from 'react-ga';

import { Hero } from './Hero';
import { WhoWeAre } from './WhoWeAre';
import { EmailCapture } from './EmailCapture';

import { 
	Icon, 
	Grid, 
	Divider,
	Segment,
	Button
} from 'semantic-ui-react';

export class Home extends Component 
{
	constructor()
	{
		super();

		let hostname = window.location.hostname;
		let debug = hostname === 'localhost' || hostname === 'captivate-website-dev.firebaseapp.com';

		GA.initialize('UA-98278140-1', {
			debug: debug
		});
	}

	handleBetaAccess()
	{
		GA.event({
			category: 'early_access',
			action: 'clicked_cta',
			label: 'click from hero'
		});

		$(document.body).animate({
			scrollTop: $('#beta-access').offset().top - 20
		}, 500);
	}

	render() 
	{	
		return (
			<div>
			<div className='app-header ui vertical masthead'>
				<div className='app-hero ui center aligned text container'>
					<Hero logo={this.props.logo} />
					<Divider hidden />
					<Divider hidden />
					<Button primary size='big' onClick={this.handleBetaAccess}>
						Play Our Games Early!
					</Button>
				</div>
			</div>
			<Grid>
				<Grid.Row>
					<Grid.Column width={16}>
						<EmailCapture />
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column width={16}>
						<WhoWeAre headerAlign='center' />
						<Divider hidden />
					</Grid.Column>
				</Grid.Row>
			</Grid>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Home.js